"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCRAPS_FOLDER_NAME = exports.ALL_FOLDER_NAME = exports.SCRAPS_FOLDER_ID = exports.ALL_FOLDER_ID = void 0;
var constants_1 = require("./constants");
var query_string_1 = __importDefault(require("query-string"));
var url_1 = __importDefault(require("url"));
var da_ddt_1 = __importDefault(require("@wix/da-ddt"));
var trim_1 = __importDefault(require("lodash/trim"));
exports.ALL_FOLDER_ID = -1;
exports.SCRAPS_FOLDER_ID = -2;
exports.ALL_FOLDER_NAME = 'All';
exports.SCRAPS_FOLDER_NAME = 'Scraps';
function getPathParts(rawPathParts) {
    return rawPathParts.filter(Boolean).join('/');
}
function toQueryStringParams(obj) {
    var parts = [];
    for (var key in obj) {
        if (obj.hasOwnProperty(key) && obj[key] !== undefined) {
            parts.push(encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]));
        }
    }
    return parts.join('&');
}
function getQueryString(obj) {
    var params = toQueryStringParams(obj);
    return params.length > 0 ? "?" + params : '';
}
/**
 * This lib is very simple, its basically an ENUM of known public
 * canonical URLs. With some helpers to generate paths for those
 * known URLs.
 *
 * Additonally it provides a way to override local development env
 * with local urls, so that when developing locally you can link to
 * your localhost rather than production base url (www.da.com)
 */
var Url = /** @class */ (function () {
    function Url() {
        this.isProduction = true;
        this.environmentFlags = [];
        this.initSSRDone = false;
        this.initClientSide();
    }
    Url.prototype.setEnv = function (isProduction, environmentFlags) {
        if (environmentFlags === void 0) { environmentFlags = []; }
        this.isProduction = isProduction;
        if (environmentFlags.length) {
            this.environmentFlags = environmentFlags;
        }
    };
    Url.prototype.setBase = function (protocol, domain, mountPointPath, port) {
        this.protocol = protocol;
        this.domain = domain;
        this.mountPointPath = mountPointPath;
        this.port = port;
    };
    Url.prototype.initServerSide = function (req) {
        this.initSSRDone = true;
        try {
            var expressProtocol = process.env.NODE_ENV === 'production' ? 'https' : req.protocol;
            var parsed = url_1.default.parse(expressProtocol + "://" + req.get('host') + req.originalUrl);
            this.setBase(parsed.protocol === 'http:' ? 'http' : 'https', parsed.hostname, parsed.path.replace(req.url, ''), Number(parsed.port));
        }
        catch (e) {
            // eslint-disable-next-line
            var debug = require('@wix/wix-debug')('URL Config');
            debug.error('Failed to init server URL config', e);
        }
    };
    Url.prototype.initClientSide = function () {
        if (typeof document === 'undefined' || typeof window === 'undefined') {
            return;
        }
        var config = window['__URL_CONFIG__'];
        if (!config) {
            da_ddt_1.default.error('URL', 'No clientside URL config found!');
            return;
        }
        this.setBase(config.protocol, config.domain, config.mountPointPath, config.port);
        this.environmentFlags = config.environmentFlags;
        this.isProduction = config.isProduction;
    };
    Url.prototype.toConfig = function () {
        var _a = this, protocol = _a.protocol, domain = _a.domain, mountPointPath = _a.mountPointPath, port = _a.port, environmentFlags = _a.environmentFlags, isProduction = _a.isProduction;
        return {
            protocol: protocol,
            domain: domain,
            port: port,
            mountPointPath: mountPointPath,
            environmentFlags: environmentFlags,
            isProduction: isProduction,
        };
    };
    Url.prototype.baseUrl = function (trailing) {
        if (trailing === void 0) { trailing = true; }
        var port = this.port ? ":" + this.port : '';
        var url = this.protocol + "://" + this.domain + port + this.mountPointPath;
        if (trailing) {
            return url.replace(/\/$/, '') + "/";
        }
        return url.replace(/\/$/, '');
    };
    Url.prototype.origin = function () {
        var port = this.port ? ":" + this.port : '';
        return this.protocol + "://" + this.domain + port;
    };
    Url.prototype.buildFromPath = function (path, baseUrl) {
        if (path === void 0) { path = ''; }
        if (baseUrl === void 0) { baseUrl = ''; }
        var url = baseUrl ? baseUrl : constants_1.URLS.ROOT;
        if (path && path.includes('://')) {
            // path is a full URL, use that instead
            url = path;
            path = null;
        }
        if (!this.isProduction) {
            url = url.replace('deviantart.com', 'deviantart.lan');
            url = url.replace('sta.sh', 'sta.nk');
        }
        if (path) {
            if (url.endsWith('/')) {
                url += path;
            }
            else {
                url += "/" + path;
            }
        }
        return url;
    };
    Url.prototype.userLink = function (username, path) {
        if (path === void 0) { path = ''; }
        if (!username) {
            return '';
        }
        username = username.toLowerCase();
        if (path !== '') {
            path = "/" + path.replace(/^\//, '');
        }
        return this.toEnvironmentUrl("/" + username + path, constants_1.PROJECTS.PROFILE);
    };
    Url.prototype.userGalleryLink = function (params) {
        return this.toEnvironmentUrl(this.userGalleryPath(params), constants_1.PROJECTS.PROFILE);
    };
    Url.prototype.userGalleryPath = function (_a) {
        var username = _a.username, gallectionType = _a.gallectionType, folderId = _a.folderId, folderName = _a.folderName, sortOrder = _a.sortOrder, searchQuery = _a.searchQuery;
        var pathParts = [
            username.toLowerCase(),
            gallectionType === 'gallery'
                ? constants_1.USER_PROFILE_SECTION_PATHS.GALLERY
                : constants_1.USER_PROFILE_SECTION_PATHS.FAVOURITES,
        ];
        if (!searchQuery && folderId && folderName) {
            if (![exports.ALL_FOLDER_ID, exports.SCRAPS_FOLDER_ID].includes(folderId)) {
                // ^ these folders are identified by name
                pathParts.push("" + folderId);
            }
            pathParts.push(folderName.toLowerCase().replace(/[^A-Za-z0-9]+/g, '-'));
        }
        var query = query_string_1.default.stringify({
            q: searchQuery ? searchQuery : undefined,
            sort: folderId === exports.ALL_FOLDER_ID || searchQuery ? sortOrder : undefined,
        });
        return "/" + pathParts.join('/') + (query ? "?" + query : '');
    };
    Url.prototype.premiumGalleryPurchasePath = function (folderId) {
        return "/premium_folders/modal/purchase/" + folderId;
    };
    Url.prototype.userSubscriptionsPath = function (_a) {
        var username = _a.username, tierDeviationId = _a.tierDeviationId, tierContentType = _a.tierContentType, anchor = _a.anchor;
        var pathParts = [username.toLowerCase(), 'subscriptions'];
        if (tierDeviationId) {
            pathParts.push("" + tierDeviationId);
            if (tierContentType) {
                pathParts.push(tierContentType);
            }
        }
        return "/" + pathParts.join('/') + (anchor ? '#content' : '');
    };
    Url.prototype.userPostsLink = function (params) {
        return this.toEnvironmentUrl(this.userPostsPath(params), constants_1.PROJECTS.PROFILE);
    };
    Url.prototype.userPostsPath = function (_a) {
        var username = _a.username, subPath = _a.subPath, sortOrder = _a.sortOrder;
        var pathParts = [
            username.toLowerCase(),
            constants_1.USER_PROFILE_SECTION_PATHS.POSTS,
            subPath,
            sortOrder,
        ].filter(function (value) { return value; });
        return "/" + pathParts.join('/');
    };
    Url.prototype.giveCoreMembership = function (username) {
        return [
            constants_1.URLS.CORE_MEMBERSHIP,
        ] + "/?mx=gift&subscribe=" + username.toLowerCase();
    };
    Url.prototype.coreMembershipLink = function (id) {
        return constants_1.URLS.CORE_MEMBERSHIP + "#" + id;
    };
    Url.prototype.userShopLink = function (username, subPath) {
        return this.toEnvironmentUrl(this.userShopPath(username, subPath), constants_1.PROJECTS.PROFILE);
    };
    Url.prototype.userShopPath = function (username, subPath) {
        return "/" + [
            username.toLowerCase(),
            constants_1.USER_PROFILE_SECTION_PATHS.SHOP,
            subPath,
        ]
            .filter(function (value) { return value; })
            .join('/');
    };
    // mirroring the php logic here
    Url.prototype.filterDeviationTitle = function (title) {
        var filtered = title.replace(/[^A-Za-z0-9]+/g, '-');
        filtered = (0, trim_1.default)(filtered, '-');
        if (!filtered) {
            return '-';
        }
        return filtered;
    };
    Url.prototype.deviationPath = function (deviationId, authorName, // author can be undefined in PapiDeviation so we are lenient...
    deviationTitle, base) {
        if (authorName === void 0) { authorName = ''; }
        if (deviationTitle === void 0) { deviationTitle = ''; }
        if (base === void 0) { base = constants_1.DEVIATION_PATHS.DEVIATION; }
        if (!authorName) {
            // We don't know the author, use the global redirector to find the correct url :)
            return "/deviation/" + deviationId;
        }
        else {
            authorName = authorName.toLowerCase();
        }
        if (deviationTitle) {
            deviationTitle = this.filterDeviationTitle(deviationTitle) + "-";
        }
        return "/" + authorName + "/" + base + "/" + deviationTitle + deviationId;
    };
    Url.prototype.deviationLink = function (deviationId, authorName, // author can be undefined in PapiDeviation so we are lenient...
    deviationTitle, base) {
        if (authorName === void 0) { authorName = ''; }
        if (deviationTitle === void 0) { deviationTitle = ''; }
        if (base === void 0) { base = constants_1.DEVIATION_PATHS.DEVIATION; }
        return this.toEnvironmentUrl(this.deviationPath(deviationId, authorName, deviationTitle, base), constants_1.PROJECTS.DEVIATION);
    };
    /**
     * Converts user provided deviation url, into a validated one
     *
     * @param url
     */
    Url.prototype.deviationLinkFromUrl = function (url) {
        if (!/^https:\/\/www\.deviantart\.com/.test(url)) {
            // Try and recover nicely
            var matches = url.match(/-([0-9]+)$/);
            if (matches) {
                return this.deviationLink(parseInt(matches[1]));
            }
            return constants_1.URLS.ROOT; // failed so fallback to root
        }
        return url;
    };
    Url.prototype.moreLikeThisLink = function (seedDeviationId) {
        return constants_1.URLS.MLT + "/" + seedDeviationId;
    };
    Url.prototype.moreLikeThisCollectionsLink = function (seedDeviationId) {
        return constants_1.URLS.MLT + "/collections/" + seedDeviationId;
    };
    Url.prototype.moreLikeThisArtistsLink = function (seedDeviationId) {
        return constants_1.URLS.MLT + "/artists/" + seedDeviationId;
    };
    /** Links to the browse tag page when given a string tag */
    Url.prototype.tagsPageLink = function (tag) {
        return constants_1.URLS.TAG + "/" + tag;
    };
    Url.prototype.forumLink = function (forumPath, threadId) {
        var forumLink = constants_1.URLS.FORUM + "/" + forumPath + "/";
        return threadId ? "" + forumLink + threadId : forumLink;
    };
    Url.prototype.printLink = function (deviationId) {
        return constants_1.URLS.ROOT + "/print/view/" + deviationId;
    };
    Url.prototype.watchLink = function () {
        return this.toEnvironmentUrl('/notifications/watch', constants_1.PROJECTS.MESSAGECENTRE);
    };
    Url.prototype.feedbackLink = function (isNewNC, section, folderId) {
        var sectionPart = section ? "/" + section : '';
        var folderPart = folderId ? "?folder=" + folderId : '';
        if (isNewNC) {
            return this.toEnvironmentUrl("/notifications", constants_1.PROJECTS.MESSAGECENTRE);
        }
        return this.toEnvironmentUrl("/notifications/feedback" + sectionPart + folderPart, constants_1.PROJECTS.MESSAGECENTRE);
    };
    Url.prototype.groupNotificationsLink = function (isNewNC, groupId) {
        if (isNewNC) {
            return this.toEnvironmentUrl("/notifications?groupId=" + groupId, constants_1.PROJECTS.MESSAGECENTRE);
        }
        return this.feedbackLink(isNewNC, undefined, groupId);
    };
    Url.prototype.notificationsHeaderLink = function () {
        return this.toEnvironmentUrl('/notifications/header', constants_1.PROJECTS.MESSAGECENTRE);
    };
    Url.prototype.browseHomeLink = function (feedType) {
        return this.toEnvironmentUrl("/" + (feedType !== null && feedType !== void 0 ? feedType : ''), constants_1.PROJECTS.BROWSE);
    };
    Url.prototype.browseDeviantsYouWatchLink = function (feedType, username) {
        if (feedType === void 0) { feedType = 'deviations'; }
        return this.toEnvironmentUrl("/watch" + (username ? "/" + username.toLowerCase() : '') + "/" + feedType, constants_1.PROJECTS.BROWSE);
    };
    Url.prototype.browsePopularLink = function (feedType) {
        if (feedType === void 0) { feedType = 'deviations'; }
        return this.toEnvironmentUrl("/popular/" + feedType, constants_1.PROJECTS.BROWSE);
    };
    Url.prototype.browseNewestLink = function (feedType) {
        if (feedType === void 0) { feedType = 'deviations'; }
        return this.toEnvironmentUrl("/new/" + feedType, constants_1.PROJECTS.BROWSE);
    };
    Url.prototype.browseGroupFeedLink = function (groupName, feedType) {
        if (feedType === void 0) { feedType = 'deviations'; }
        return this.toEnvironmentUrl("/groups/" + groupName + "/" + feedType, constants_1.PROJECTS.BROWSE);
    };
    Url.prototype.searchLink = function (q, basePath) {
        if (basePath === void 0) { basePath = '/search'; }
        var path = "" + basePath + (q ? getQueryString({ q: q }) : '');
        return this.toEnvironmentUrl(path, constants_1.PROJECTS.BROWSE);
    };
    Url.prototype.browsePostsLink = function () {
        return this.toEnvironmentUrl('/posts', constants_1.PROJECTS.BROWSE);
    };
    Url.prototype.browseCommissionsLink = function () {
        return this.toEnvironmentUrl('/commissions', constants_1.PROJECTS.BROWSE);
    };
    Url.prototype.browseTopicsLink = function (topic) {
        var topicPath = topic ? "/" + topic : '';
        return this.toEnvironmentUrl("/topic" + topicPath, constants_1.PROJECTS.BROWSE);
    };
    Url.prototype.browseDailyDeviationsLink = function (rawDate) {
        var date;
        if (rawDate) {
            var fullYear = rawDate.getFullYear();
            var month = rawDate.getMonth() + 1;
            var day = rawDate.getDate();
            var twoDigitMonth = month > 9 ? month : "0" + month;
            var dateOfMonth = day > 9 ? day : "0" + day;
            date = fullYear + "-" + twoDigitMonth + "-" + dateOfMonth;
        }
        var path = "/daily-deviations" + getQueryString({ date: date });
        return this.toEnvironmentUrl(path, constants_1.PROJECTS.BROWSE);
    };
    Url.prototype.browseJournalsLink = function (_a) {
        var _b = _a === void 0 ? {} : _a, order = _b.order, faucet2 = _b.faucet2, popularWindow = _b.popularWindow;
        var pathParts = getPathParts(['journals', faucet2]);
        var path = "/" + pathParts + getQueryString({
            order: order,
            popularWindow: popularWindow,
        });
        return this.toEnvironmentUrl(path, constants_1.PROJECTS.BROWSE);
    };
    Url.prototype.commentLink = function (commentableTypeId, commentableItemId, commentId, editId, embed, openReply) {
        if (editId === void 0) { editId = undefined; }
        if (embed === void 0) { embed = false; }
        if (openReply === void 0) { openReply = undefined; }
        var path = [
            commentableTypeId,
            commentableItemId,
            commentId,
            editId,
        ].filter(Boolean);
        if (embed) {
            path.unshift('embed');
        }
        path.unshift('comments');
        return this.toEnvironmentUrl("/" + path.join('/') + (openReply ? "?reply_to=" + commentId : ''), constants_1.PROJECTS.COMMENTS);
    };
    Url.prototype.loginLink = function () {
        return this.toEnvironmentUrl('/users/login', constants_1.PROJECTS.SISU);
    };
    Url.prototype.joinLink = function (joinpoint) {
        return this.toEnvironmentUrl(
        // The 'joinpoint' query param here is used by BI to
        // track where the signup link came from.
        // Also, the slash at the end is required to avoid a double redirect by haproxy
        "/join/" + (joinpoint ? "?joinpoint=" + joinpoint : ''), constants_1.PROJECTS.SISU);
    };
    Url.prototype.groupnoteLink = function (username, noteId) {
        return this.userLink(username, "notes/" + noteId);
    };
    Url.prototype.groupLogLink = function (username, messageId) {
        return this.userLink(username, "messages/" + messageId + "/");
    };
    Url.prototype.badgesLink = function (username, badgeId) {
        return this.userLink(username, 'badges') + (badgeId ? "/" + badgeId + "/" : '');
    };
    Url.prototype.userNoteLink = function (username) {
        return constants_1.URLS.NOTES + "/#to=" + username.toLowerCase();
    };
    Url.prototype.chatroomInStandalone = function (chatroomId, tab) {
        var tabQuery = tab ? "&tab=" + tab : '';
        return constants_1.URLS.CHAT_HOME + "?room=" + chatroomId + tabQuery;
    };
    Url.prototype.directMessageInStandalone = function (userUuid) {
        return constants_1.URLS.CHAT_HOME + "?dm=" + userUuid;
    };
    Url.prototype.staticCDNLink = function (resource) {
        return constants_1.URLS.CDN + "/" + resource;
    };
    Url.prototype.checkoutLink = function (subProductId) {
        return this.toEnvironmentUrl("/purchase?id=" + subProductId, constants_1.PROJECTS.PONIES);
    };
    Url.prototype.checkoutCompleteLink = function (orderGroupId, referer) {
        return this.toEnvironmentUrl("/purchase/complete" + getQueryString({
            id: orderGroupId,
            referer: referer,
        }), constants_1.PROJECTS.PONIES);
    };
    Url.prototype.toEnvironmentUrl = function (path, projectFlag) {
        this.checkServerInit();
        if ((typeof window !== 'undefined' && window['__XHR_LOCAL__']) ||
            (typeof process !== 'undefined' && process.env['XHR_ENV'] === 'vm')) {
            // Client-side URLs to any project on the VM
            return "" + this.origin() + path;
        }
        if (this.hasEnvironmentFlag(projectFlag)) {
            return "" + this.baseUrl(false) + path;
        }
        return "" + constants_1.URLS.ROOT + path;
    };
    Url.prototype.hasEnvironmentFlag = function (flag) {
        if (this.isProduction) {
            return false;
        }
        return Boolean((this.environmentFlags || []).find(function (v) { return v === flag; }));
    };
    Url.prototype.checkServerInit = function () {
        if ((typeof document === 'undefined' || typeof window === 'undefined') &&
            !this.initSSRDone) {
            da_ddt_1.default.log('URL', 'SSR url was not initialised before use, you probably have two instances');
        }
    };
    return Url;
}());
exports.default = Url;
//# sourceMappingURL=url.js.map